<template lang="pug">
v-container(fluid fill-height class="")
  v-row(no-gutters)
    v-col
      v-row
        v-col
          span(class=" tw-text-2xl text-secondary tw-font-bold") {{ $t('Settings.Common.inviteTeamMember') }}
      v-row
        v-col
          v-form(ref="form" v-model="valid" lazy-validation @keyup.navtive.enter="valit && submit($event)")
            v-row
              v-col
                v-text-field(v-model="invitation.email" :label="$t('Common.email')" outlined hide-details)
              v-col(cols="4")
                v-select(
                  v-model="invitation.role"
                  item-text="label"
                  item-value="value"
                  :items="$t('Settings.Common.roles')"
                  outlined
                )
      v-row(justify="end")
        v-col(cols="auto" class="tw-h-full fill-height")
          v-btn(@click="$emit('close')" text :ripple="false")
            span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
          v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="submit")
            span(class="tw-font-bold") {{ $t('Settings.Common.sendInvitation') }}
</template>
<script>
export default {
  data() {
    return {
      invitation: {},
      loading: false,
      valid: true,
    };
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.invitation.team = this.$store.getters['auth/authUser'].current_team.id;
        await this.$store
          .dispatch('team/addInvitation', this.invitation)
          .then(() => {
            this.invitation = {};
            this.loading = false;
            this.$emit('close');
          })
          .catch((error) => {
            this.$store.commit('SET_ERROR', error, { root: true });
            this.loading = false;
          });
      }
    },
  },
};
</script>
